import ModuleRegistry from 'react-module-container/dist/src/module-registry';
export var REGISTER_TO_INTANCE_CHANGE_METHOD_NAME = 'businessManager.registerToInstanceChanges';
export var GET_CURRENT_INSTANCE_METHOD_NAME = 'businessManager.getCurrentInstance';
export var REFRESH_INSTANCE_METHOD_NAME = 'businessManager.refreshInstance';
export var registerToInstanceChanges = function (appDefId, callback) {
    return ModuleRegistry.invoke(REGISTER_TO_INTANCE_CHANGE_METHOD_NAME, appDefId, callback);
};
export var getCurrentInstance = function (appDefId) {
    return ModuleRegistry.invoke(GET_CURRENT_INSTANCE_METHOD_NAME, appDefId);
};
export var refreshInstance = function (appDefId) {
    return ModuleRegistry.invoke(REFRESH_INSTANCE_METHOD_NAME, appDefId);
};
//# sourceMappingURL=instancesHandling.js.map